import React from 'react';
import Navbar from './Navbar';
import HeroSection from './HeroSection';
import WeAreSection from './WeAreSection';
import QuotationSection from './QuotationSection';
import HowWeWorkSection from './HowWeWorkSection';
import BookMeetingCTA from './BookMeetingCTA';
import AdvantageSection from './AdvantageSection';
import ExistingProjectCTA from './ExistingProjectCTA';
import StatsSection from './StatsSection';
import HowItWorksSection from './HowItWorksSection';
import TransformCTA from './TransformCTA';
import IndustriesSection from './IndustriesSection';
import TrustedBySection from './TrustedBySection';
import Footer from './Footer';

const HomePage: React.FC = () => {
  return (
    <div className="w-full bg-white">
      <Navbar />
      <HeroSection />
      <WeAreSection />
      <QuotationSection />
      <TrustedBySection />
      <BookMeetingCTA />
      <HowWeWorkSection />
      <AdvantageSection />
      <StatsSection />
      <ExistingProjectCTA />
      <HowItWorksSection />
      <IndustriesSection />
      <TransformCTA />
      <Footer />
    </div>
  );
};

export default HomePage;
